/**
 * errorCode -> i18n key for a saved-filter call refused because a dependency is down.
 *
 * CONSTRAINT: the BFF replaces any OPREF 5xx on a list/detail read with `OprefUnavailable`
 * (`SavedFiltersService.BuildServiceUnavailable`), so the OPREF codes reach the FE on writes only.
 */
export const SAVED_FILTER_UNAVAILABLE_KEYS = {
    "SavedFilter.Access.Unavailable": "advancedFilterLibrary.errors.unavailable",
    "SavedFilter.Curation.Unavailable": "advancedFilterLibrary.errors.unavailable",
    OprefUnavailable: "advancedFilterLibrary.errors.unavailable",
};
